import { render, staticRenderFns } from "./TransactionOk.vue?vue&type=template&id=f817d608"
import script from "./TransactionOk.vue?vue&type=script&lang=js"
export * from "./TransactionOk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports